<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <el-empty
    :image="image"
    :description="displayText"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import EmptyImg from '@/assets/images/empty.webp'

const { t } = useI18n()

const props = withDefaults(defineProps<{
  image?: string
  text?: string
}>(), {
  image: EmptyImg,
  text: undefined,
})

const displayText = computed(() => {
  return props.text ?? t('common.no_data')
})
</script>
